import styled, { css } from "styled-components";

export const PrevidenciaContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  padding-bottom: 16px;
  form {
    margin-top: 16px;
  }

  .ant-form-item-row {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-bottom: -16px;
  }
  .ant-input.ant-input-lg {
    height: 40px;
  }
  .rows {
    width: 100% !important;
    max-width: 100% !important;
    display: flex;
  }
  .cols {
    display: flex;
  }
  .form-item {
    width: 80% !important;
  }

  .ant-form-item-label {
    margin-right: 10px;
  }

  .ant-form-item-control {
    width: 50% !important;
    max-width: 50% !important;
  }
  input {
    border-radius: 0 !important;
  }
  button {
    margin: 24px 0 0;
    border-radius: 0 !important;
    font-size: 16px !important;
    font-weight: 500 !important;
  }
  .list-pgbl {
    font-weight: 500;
    margin-bottom: 16px;
  }
  ul li {
    font-size: 12px;
    list-style-type: circle;
    list-style: circle;
    margin-left: 32px;
  }
  .ant-select ant-select-lg ant-select-single ant-select-show-arrow {
    height: 40px !important;
  }
  .ant-select-lg,
  .ant-select-lg .ant-select-selector {
    height: 40px !important;
    margin-top: 2px !important;
    border-radius: 0px !important;
  }
  .ant-select-selector {
    width: 120px !important;
    height: 40px !important;
    display: flex !important;
    align-items: center !important;
    margin-left: 16px !important;
    border-radius: 0px !important;
  }

  .previdencia-card {
    width: 100%;
    padding: 24px;
    border-radius: 8px;
    background-color: var(--white);
    border: 1px solid var(--ghost);
    box-shadow: 0px 4px 8px 0px var(--ghost);
    display: flex;
    margin-bottom: 8px;
    &:last-of-type {
      margin-bottom: 32px;
    }
    & > svg {
      min-width: 24px;
      min-height: 24px;
      stroke: var(--ant-primary-color);
      &.fill {
        fill: var(--ant-primary-color);
      }
    }

    .previdencia-card-content {
      width: 100%;
      justify-content: center;
      div.ant-typography {
        color: var(--gray-1);
        font-size: 16px;
        font-weight: 300;
      }
      .title {
        font-size: 20px;
        font-weight: 600;
      }
    }
    .header-box {
      font-size: 14px;
      padding: 8px;
      font-weight: 300;
      line-height: 1rem;
      height: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
    }

    .header-border-top {
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
    }

    .header-border-left {
      border-top-left-radius: 8px;
    }

    .header-border-right {
      border-top-right-radius: 8px;
    }

    .header-box-bottom {
      width: 100%;
    }

    .header-box-black {
      background-color: #1f1f1f;
    }

    .header-box-green {
      background-color: var(--green) !important;
    }

    .header-box-red {
      background-color: var(--red) !important;
    }
  }
  .pgbl-info-button {
    margin: 0 0 0 4px;
    padding: 4px;
    font-size: 12px;
    display: flex;
    column-gap: 4px;
    align-items: center;
    font-weight: 500;
    svg {
      width: 18px;
      height: 18px;
      min-width: 18px;
      min-height: 18px;
    }
    
  }
  .card-bottom {
      background-color: #f0f0f0;
  }

  @media only screen and (max-device-width: 812px) {
    .previdencia-card {
      .previdencia-card-content {
        padding: 0;
        .title {
          margin: 0;
        }

        h1 {
          width: 250px !important;
          margin: 0 !important;
          padding: 0 !important;
          font-size: 12px !important;
        }
        ul, li {
          margin: 0 !important;
          padding: 0 !important;
        }
        form {
          margin: 8px 0 0;
          button {
            margin: 16px 0 0;
          }
          .form-item {
            width: 100% !important;
          }
          .cols {
            position: relative;
          }
          .tabs {
            top: 4px;
            right: 24px;
            height: 24px;
            position: absolute;
            width: 50px !important;
            max-width: 50px !important;
            min-width: 50px !important;
            margin-left: 8px !important;
            .ant-tabs-content-holder {
              height: 0;
              flex: 0;
            }
            .ant-tabs-nav {
              height: 24px;
            }
          }
          .ant-row {
            width: 100%;
            .ant-form-item-label {
              padding-bottom: 4px;
              height: auto !important;
              label {
                height: auto !important;
                font-weight: 500;
                font-size: 12px;
                line-height: 16px;
                white-space: normal;
              }
            }

            .ant-form-item-control {
              height: 32px !important;
              width: 100% !important;
              max-width: 100% !important;
              input {
                height: 32px !important;
                font-weight: 500;
                font-size: 12px;
                width: 100%;
                margin-bottom: 8px;
              }
            }
          }
          .ant-select {
            align-self: flex-end;
            margin: 0 0 8px 8px !important;
            .ant-select-selector {
              margin: 0 !important;
              height: 32px !important;
              width: 100px !important;
              font-size: 12px !important;
              .ant-select-selection-item {
                font-size: 12px !important;
              }
            }
            .ant-select-item-option-content {
              font-size: 12px !important;
            }
          }
          .ant-select-open {
            height: 32px !important;
            width: 120px !important;
            font-size: 12px !important;
          }
          .ant-select-show-arrow {
            height: 32px !important;
          }
          .pgbl-info-button {
            margin: 4px 0 0 4px;
            padding: 4px;
            font-size: 12px;
            display: flex;
            column-gap: 4px;
            align-items: center;
            font-weight: 500;
            svg {
              width: 16px;
              height: 16px;
              min-width: 16px;
              min-height: 16px;
            }
          }
        }
      }
    }
    .card-bottom {
      background-color: #f0f0f0;
      .list-pgbl {
        font-size: 12px !important;
      }
      li {
        width: 350px;
        font-size: 10px !important;
      }
    }
  }
`;

interface QuestionProps {
  show?: boolean;
}

export const Question = styled.div<QuestionProps>`
  width: 100%;
  padding: 32px;
  border-radius: 4px;
  background-color: var(--white);

  ${({ show }) =>
    show
      ? css`
          display: block;
          visibility: visible;
        `
      : css`
          display: none;
          overflow: hidden;
          visibility: hidden;
          max-height: 100px;
        `}

  .question-title {
    display: flex;
    align-items: flex-start;
    font-size: 1.7rem;
    margin-bottom: 1rem;
    margin-top: 1rem;
    font-weight: 700;

    button.ant-btn-text {
      padding: 4px;
      span {
        width: 20px;
        height: 20px;
      }
    }
  }

  .question-buttons {
    margin-top: 24px;
  }

  &,
  .anticon,
  .question-title,
  .ant-radio-wrapper,
  .ant-checkbox + span {
    color: var(--velotax-font-color-dark) !important;
  }

  .ant-tabs {
    color: var(--velotax-font-color) !important;
    .ant-tabs-nav {
      .ant-tabs-nav-wrap {
        flex-grow: 0;
        flex-shrink: 1;
        flex-basis: 140px;
        .ant-tabs-tab {
          padding: 4px 0;
        }
      }
      .anticon svg {
        color: var(--velotax-font-color-dark) !important;
      }
    }
  }

  .pgbl-info-button {
    padding: 4px;
    font-size: 12px;
    display: flex;
    column-gap: 4px;
    align-items: center;
    font-weight: 500;
  }

  .income-types {
    margin-bottom: 1rem;
    p {
      margin: 0;
      font-size: 1rem;
      display: flex;
      column-gap: 8px;
      span {
      }
    }
  }

  &.resume-container {
    font-size: 1.25rem;
    text-align: center;
    position: relative;
    .ant-typography {
      color: var(--velotax-font-color-dark) !important;
    }
    .assessor-text {
      font-size: 12px;
      margin: 16px 0 0;
      text-align: center;
    }
    button {
      margin-top: 16px;
    }
    .content-body {
      height: 64px;
      padding: 14px;
      display: flex;
      align-items: center;
      font-size: 14px;
    }

    .border-left-right {
      border-left: 1px solid #e8e8e8;
      border-right: 1px solid #e8e8e8;
      border-bottom: 1px solid #e8e8e8;
    }

    .border-right-white {
      border-right: 1px solid white;
    }

    .border-left-white {
      border-left: 1px solid white;
    }

    .border-bottom-right-radius {
      border-bottom-right-radius: 0.25rem;
    }

    .border-bottom-left-radius {
      border-bottom-left-radius: 0.25rem;
    }

    .text-left {
      text-align: start;
    }

    .text-center {
      align-items: center;
      display: flex;
      justify-content: center;
    }

    .background-gain {
      background-color: #e8e8e8;
    }

    .col-header {
      width: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
    }

    .btn-download {
      font-size: 14px !important;
      display: flex;
      padding: 5px;
      flex-direction: row;
      justify-content: space-around;
      align-items: center;
      width: 100px;
      margin: 0px 0px 0px 0px;
      border-radius: 20px !important;
    }

    .restituicao {
      width: 100%;
      margin: 16px 0;
      justify-content: space-between;
      display: flex;
      flex-direction: row;
      gap: 2px;
      .ant-typography {
        .content-header {
          height: 70px;
          font-size: 1.5rem;
          font-weight: 700;
          border-left: 1px solid #e8e8e8;
          border-right: 1px solid #e8e8e8;
          border-bottom: 1px solid #e8e8e8;
          border-radius: 0.25rem;
          padding: 14px;
          display: flex;
          align-items: center;
          flex-direction: column;
          
          .text-green {
            color: var(--green);
          }

          .text-red {
            color: var(--red);
          }
        }

        .background-icon-circle {
          background-color: var(--yellow);
          height: 55px;
          width: 55px;
          border-radius: 34px;

          .icon-circle {
            margin-top: 15px;
          }
        }

        .with-icon {
          flex-direction: row;
          gap: 12px;
        }
      }
    }
  }

  @media only screen and (max-device-width: 812px) {
    padding: 24px;
    margin: 0;
    .question-buttons {
      button {
        font-size: 0.85rem;
        letter-spacing: 0.5px;
        padding-left: 16px;
        padding-right: 16px;
      }
    }
    &.resume-container {
      padding: 0;
      font-size: 0.5rem;
      button {
        margin: 0;
      }
      .restituicao {
        justify-content: center;
        .ant-typography {
          strong {
            font-size: 13px;
          }
          div {
            font-size: 12px;
            font-weight: 600;
            br {
              display: block;
            }
          }
          .background-icon-circle {
            background-color: var(--yellow);
            height: 22px !important;
            width: 22px !important;
            border-radius: 34px;
  
            .icon-circle {
              margin-top: 5px;
            }
          }

          .span-text-inside {
            font-size: 14px;
          }
        }
      }
      .resume-edit-button {
        top: 16px;
        right: 16px;
      }
    }
    .small-text {
      font-size: 10px;
      letter-spacing: 0px;
      padding-left: 8px;
      padding-right: 8px;
    }

    .question-title {
      flex-direction: column;
    }
    .pgbl-info-button {
      padding: 4px 0;
      text-align: left;
    }

    .handle-label {
      .MuiFormLabel-root.MuiInputLabel-root.MuiInputLabel-shrink {
        min-width: 133%;
        white-space: normal;
        transform: translate(0, -12px) scale(0.75);
      }
    }

    .row-mobile {
      min-height: 330px;

      .content-body  {
        height: 90px;
        padding: 7px;
        font-size: 11px;
      }
    }
  }
`;
